import {
  Priority,
  RegulatoryCluster,
  TodoCategory
} from "../../utils/backend-types";
import { TodoSystemDecision, TodoUserDecision } from "./Todos.types";

export const CATEGORIES = {
  ONBOARDING: {
    displayName: "Onboarding",
    value: TodoCategory.Onboarding
  },
  REGULATORY_DUTY: {
    displayName: "Regulatorische Pflicht",
    value: TodoCategory.RegulatoryDuty
  },
  OTHER: {
    displayName: "Andere",
    value: TodoCategory.Other
  }
};

export const CLUSTERS = {
  ONBOARDING: {
    displayName: "Onboarding",
    value: RegulatoryCluster.Onboarding
  },
  REGULATORY_DUTY: {
    displayName: "Regulatorische Pflicht",
    value: RegulatoryCluster.RegulatoryDuty
  },
  OTHER: {
    displayName: "Andere",
    value: RegulatoryCluster.Other
  },
  ASSESSMENT_PROFITABILITY_AND_FEASIBILITY: {
    displayName: "Bewertung Wirtschaftlichkeit und Machbarkeit",
    value: RegulatoryCluster.AssessmentProfitabilityAndFeasibility
  },
  PLANNING_AND_REALISATION: {
    displayName: "Projektierung und Realisierung PV - Anlage",
    value: RegulatoryCluster.PlanningAndRealisation
  },
  METERING_CONCEPT_AND_OPERATIONS: {
    displayName: "Messkonzept und Messstellenbetrieb",
    value: RegulatoryCluster.MeteringConceptAndOperations
  },
  DIRECT_MARKETING: {
    displayName: "Direktvermarktung",
    value: RegulatoryCluster.DirectMarketing
  },
  POWER_SUPPLY_TO_TENANT_AND_CUSTOMER: {
    displayName: "Dachpacht und Stromlieferung an Mieter / Kunden",
    value: RegulatoryCluster.PowerSupplyToTenantAndCustomer
  },
  PROJECT_OVERVIEW: {
    displayName: "Projekt - Übersicht",
    value: RegulatoryCluster.ProjectOverview
  }
};

export const TSDROPDOWN_PRIORITIES = {
  HIGH: {
    displayName: "High",
    value: Priority.High
  },
  MEDIUM: {
    displayName: "Medium",
    value: Priority.Medium
  },
  LOW: {
    displayName: "Low",
    value: Priority.Low
  },
  UNKNOWN: {
    displayName: "Ohne",
    value: Priority.Unknown
  }
};
export const PRIORITIES = [
  { label: "High", value: Priority.High },
  { label: "Medium", value: Priority.Medium },
  { label: "Low", value: Priority.Low },
  { label: "Ohne", value: Priority.Unknown }
];

export const TODO_DOCUMENT_STATUS = [
  { label: "Offen", value: "false" },
  { label: "Dokumente bereitgestellt", value: "true" }
];

export const TODO_SYSTEM_DECISION_BY_USER_DECISION = {
  [TodoUserDecision.Confirmed]: TodoSystemDecision.Applicable,
  [TodoUserDecision.Rejected]: TodoSystemDecision.NotApplicable,
  [TodoUserDecision.Unclear]: TodoSystemDecision.CantTell
};

export const SYSTEM_USER_NAME = "System User";
export const UNKNOWN_USER = "Unbekannte Person";

export const DECISION_TEXTS = {
  [TodoSystemDecision.Applicable]: {
    displayName: "Als offen übernehmen",
    explanation:
      'Diese Aufgaben wurden auf Basis Ihrer Projekt-Konfiguration als für Sie einschlägig erkannt. Durch Auswahl von "Als offen übernehmen" wird die Aufgabe in Ihre Aufgabenliste übernommen. Wenn Sie "Als erledigt übernehmen" auswählen, wird die Aufgabe übernommen und direkt als erledigt markiert.'
  },
  APPLICABLE_FINISHED: {
    displayName: "Als erledigt übernehmen",
    explanation: ""
  },
  [TodoSystemDecision.CantTell]: {
    displayName: "Klärung ausstehend",
    explanation:
      "Auf Basis Ihrer Angaben konnte noch nicht abschließend bewertet werden, ob diese Aufgaben für Sie einschlägig sind. Durch Klick auf den Titel einer Aufgabe erhalten Sie eine Beschreibung mit weiterführenden Informationen. Sollten Sie unsicher sein, ob eine Aufgabe erfüllt werden muss , steht Ihnen Ihr Ansprechpartner jederzeit gerne zur Verfügung."
  },
  [TodoSystemDecision.NotApplicable]: {
    displayName: "Nicht übernehmen",
    explanation:
      "Diese Aufgaben wurden vom System als für Sie nicht relevant erkannt bzw. entsprechend von Ihnen gekennzeichnet. Sofern Sie keine Änderungen vornehmen, werden die Aufgaben nicht in Ihre Aufgabenliste übernommen."
  }
};

export const DECISION_OPTIONS = [
  {
    decision: TodoUserDecision.Confirmed,
    finished: false,
    displayName: DECISION_TEXTS[TodoSystemDecision.Applicable].displayName
  },
  {
    decision: TodoUserDecision.Confirmed,
    finished: true,
    displayName: DECISION_TEXTS["APPLICABLE_FINISHED"].displayName
  },
  {
    decision: TodoUserDecision.Unclear,
    finished: false,
    displayName: DECISION_TEXTS[TodoSystemDecision.CantTell].displayName
  },
  {
    decision: TodoUserDecision.Rejected,
    finished: false,
    displayName: DECISION_TEXTS[TodoSystemDecision.NotApplicable].displayName
  }
];

export const FIRST_SUPPORTED_ONBOARDING_TODO_YEAR = 2020;
export const LAST_SUPPORTED_ONBOARDING_TODO_YEAR = 2023;

export enum OnboardingTodo {
  KONFIGURATION_PRUEFEN,
  AUFGABENLISTE_MIT_REGULATORISCHEN_PFLICHTEN_ANLEGEN,
  REGULATORISCHE_DATEN_VERVOLLSTAENDIGEN,
  HISTORISCHE_MESSDATEN_AUS_UNTERMESSSYSTEMEN_BEREITSTELLEN,
  HISTORISCHE_MESSDATEN_AUS_UNTERMESSSYSTEMEN_INTEGRIEREN,
  VOLLMACHT_FUER_MSB_BEREITSTELLEN,
  VOLLMACHT_FUER_VERMARKTER_BEREITSTELLEN,
  HISTORISCHE_MSB_DATEN_INTEGRIEREN,
  KONTINUIERLICHER_MSB_DATENEMPFANG_EINRICHTEN,
  KONTINUIERLICHER_MESSDATENEMPFANG_AUS_UNTERMESSSYSTEMEN_EINRICHTEN,
  MESS_UND_BILANZIERUNGSKONZEPT_ERSTELLEN,
  LIEFERKONDITIONEN_HINTERLEGEN_STROMLIEFERUNG_UND_ABRECHNUNG,
  MESSKONZEPT_UND_ZAEHLERKONFIGURATION_DATEN_VERVOLLSTAENDIGEN,
  DIREKTVERMARKTUNGSVERTRAEGE_HINTERLEGEN,
  P6_VERTRAEGE_HINTERLEGEN
}
